(() => {
  if (customElements.get('z-native-card-colours')) return;
  customElements.define('z-native-card-colours', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.card = this.closest('product-component');
      if (!this.originalImages) this.originalImages = this.images().map(image => image.cloneNode());
      try { this.variants = JSON.parse(this.querySelector('[data-native-colour-variants]').textContent); }
      catch (_) { return; }
      this.buttons = [...this.querySelectorAll('[data-native-colour]')];
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-native-colour]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        this.select(button);
      }, { signal: this.events.signal });
      const images=this.images();
      if(images[0])this.restoreSharedPreview=window.ZicoCardColours?.preview(this.card,images[0],images[1],this.buttons.map(control=>({control,image:control.dataset.primary})));
      window.ZicoCardColours?.compact(this,'[data-native-colour]');
      this.filterQuickOptions(this.dataset.color);
    }
    disconnectedCallback() { this.events?.abort(); }
    images() { return [...this.card.querySelectorAll('.card__media .media > img')]; }
    restoreOriginalImages() {
      const images = this.images();
      if (!images.length || !this.originalImages.length) return;
      this.originalImages.forEach((original,index) => {
        const image=images[index];
        if(!image)return;
        for(const name of ['src','srcset','style','alt','hidden']) {
          const value=original.getAttribute(name);
          if(value===null)image.removeAttribute(name);else image.setAttribute(name,value);
        }
      });
      images.slice(this.originalImages.length).forEach(image=>image.hidden=true);
    }
    preview(button) {
      if (!button.dataset.primary) return;
      const images = this.images();
      if (!this.previewState) this.previewState = images.map(image => ({ image, src: image.getAttribute('src'), srcset: image.getAttribute('srcset'), style: image.getAttribute('style') }));
      images.forEach((image, index) => {
        image.style.opacity = index ? '0' : '1';
        if (!index) { image.src = button.dataset.primary; image.removeAttribute('srcset'); }
      });
    }
    restorePreview() {
      this.restoreSharedPreview?.();
      if (!this.previewState) return;
      for (const { image, src, srcset, style } of this.previewState) {
        for (const [key, value] of Object.entries({ src, srcset, style })) value === null ? image.removeAttribute(key) : image.setAttribute(key, value);
      }
      this.previewState = null;
    }
    filterQuickOptions(color) {
      const source = this.card.querySelector('[data-zico-card-product]');
      if (!source) return;
      const data = JSON.parse(source.textContent);
      data.variants = this.variants.filter(variant => variant.options[Number(this.dataset.colorIndex)] === color);
      const next = source.cloneNode();
      next.textContent = JSON.stringify(data);
      source.replaceWith(next);
      const hover = this.card.querySelector('.zico-size-hover');
      if (hover) { delete hover.dataset.zicoToneValue; delete hover.dataset.zicoSizeSignature; }
      document.dispatchEvent(new CustomEvent('zico:card-colour-change', { detail: { card: this.card } }));
    }
    async select(button) {
      this.restorePreview();
      const ticket=this.selectionTicket=(this.selectionTicket||0)+1;
      if(button.dataset.primary) {
        try { await window.ZicoCardColours.ready(button.dataset.primary); }
        catch { return; }
      }
      if(ticket!==this.selectionTicket||!this.isConnected)return;
      this.dataset.color = button.dataset.nativeColour;
      this.buttons.forEach(item => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      this._zCompactUpdate?.();
      const images = this.images();
      if (images[0] && button.dataset.primary) {
        images[0].src = button.dataset.primary;
        images[0].removeAttribute('srcset');
        images[0].alt = button.title;
        const secondary = button.dataset.secondary;
        if (secondary && !images[1]) {
          const image = images[0].cloneNode();
          images[0].after(image); images.push(image);
        }
        if (images[1]) {
          images[1].hidden=!secondary;
          if (secondary) { images[1].src = secondary; images[1].removeAttribute('srcset'); images[1].style.removeProperty('display'); }
        }
        images[0].style.opacity = secondary ? '' : '1';
      } else this.restoreOriginalImages();
      this.card.querySelectorAll('a[href*="/products/"]').forEach(link => {
        const url = new URL(link.href); url.searchParams.set('variant', button.dataset.variant); link.href = url.href;
      });
      this.card.querySelectorAll('.zico-card-color').forEach(label => { label.textContent = button.title; });
      const state = [...this.querySelectorAll('template[data-native-colour-state]')].find(template => template.dataset.nativeColourState === button.dataset.nativeColour);
      const price = this.card.querySelector('.price');
      const nextPrice = state?.content.querySelector('.price');
      if (price && nextPrice) price.replaceWith(nextPrice.cloneNode(true));
      if (!this.hasAttribute('data-release')) {
        const soldOut = button.dataset.available !== 'true';
        this.card.toggleAttribute('data-zico-card-sold-out-color', soldOut);
        if (soldOut) this.card.dataset.zicoCardSoldOutColor = 'true';
        this.card.querySelectorAll('.card__badge').forEach(container => {
          const nextBadge = state?.content.querySelector('[data-native-colour-badge] .badge');
          const id = container.querySelector('.badge')?.id;
          container.replaceChildren();
          if (nextBadge) { const badge = nextBadge.cloneNode(true); if (id) badge.id = id; container.append(badge); }
        });
      }
      this.card.dataset.zProductColour=button.dataset.nativeColour;
      this.filterQuickOptions(button.dataset.nativeColour);
      delete this.card.dataset.zSecondaryReady;
      this.card.dispatchEvent(new CustomEvent('zico:media-changed'));
    }
  });
})();



